import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";


const PhoneIcon = (props: any) => {
    return (
        <SvgIcon {...props}>
            <svg className="icon" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="11925" width="24" height="24">
                <path
                    d="M761.984 12.032H262.016C216 12.032 178.688 49.28 178.688 95.36v833.28c0 46.08 37.312 83.328 83.328 83.392h499.968c46.016-0.064 83.328-37.376 83.328-83.392V95.36c0-46.08-37.312-83.328-83.328-83.328zM234.24 95.36c0-15.36 12.416-27.776 27.776-27.776h499.968c15.36 0 27.776 12.416 27.776 27.776v638.848H234.24V95.36z m555.52 833.28c0 15.36-12.416 27.776-27.776 27.776H262.016a27.776 27.776 0 0 1-27.776-27.776v-138.88h555.52v138.88z"
                    p-id="11926"/>
                <path d="M456.448 873.088a55.552 55.552 0 1 0 111.104 0 55.552 55.552 0 0 0-111.104 0z"
                      p-id="11927"/>
            </svg>
            ;
        </SvgIcon>
    );
};

export default PhoneIcon;
